import {call, put, takeLatest} from "redux-saga/effects";
import {TreatmentPlanTemplatesAPI} from "../../../api/treatmentPlansAPI";
import {ToastType} from "../../../utils/interfaces";
import {
  SET_TOAST,
  UPDATE_MEDICATION_TEMPLATE_ERROR,
  UPDATE_MEDICATION_TEMPLATE_REQUEST,
  UPDATE_MEDICATION_TEMPLATE_SUCCESS
} from "../../actions";

function* workerUpdateMedicationTemplate(action: {
  type: string;
  payload: {data: any; callback: Function, navigate: Function};
}): Generator<any> {
  try {
    const {data, navigate, callback} = action.payload;
    const response: any = yield call(
      TreatmentPlanTemplatesAPI.updateMedicationTemplate,
      data,
      data.id
    );
    yield put({
      type: UPDATE_MEDICATION_TEMPLATE_SUCCESS
    });
    callback();
    navigate(`/medication-templates/view/${response.id}`);
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Changes were successfully saved",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: UPDATE_MEDICATION_TEMPLATE_ERROR,
      payload: {code: error.response.status, message: error.message}
    });

    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message:
          error?.response?.data
            && Object.values(error?.response?.data).length
            && typeof Object.values(error?.response?.data)[0] === 'string'
            ? Object.values(error?.response?.data)[0]
            : "An error occurred while updating Medication Template",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherUpdateMedicationTemplate() {
  yield takeLatest(
    UPDATE_MEDICATION_TEMPLATE_REQUEST,
    workerUpdateMedicationTemplate
  );
}
